import { render, staticRenderFns } from "./ServicioExterno.vue?vue&type=template&id=75925ebd"
import script from "./ServicioExterno.vue?vue&type=script&lang=js"
export * from "./ServicioExterno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports